import ItemModel from "../item-model"
import {ItemDisplay} from "../@type";

// const debug = "listItem_UpdateDisplayNumbers"
const debug = false

export default function listItem_UpdateDisplayNumberRecursively(parentItem: ItemModel | undefined, listItem:ItemModel, currentNumber: number) {

    debug && console.log(debug, 'process', currentNumber, listItem.getName(), listItem.display, listItem)

    switch (listItem.display) {

        case ItemDisplay.VISIBLE:
        case ItemDisplay.GHOST_VISIBLE:
            currentNumber++

            debug && console.log(debug, 'process visible', currentNumber, listItem.getName())

            listItem.displayNumber = currentNumber
            listItem.updateLastUpdateTime()
            break

        case ItemDisplay.HIDDEN:
        case ItemDisplay.GHOST_HIDDEN:
        default:
            // do nothing
            break
    }

    _.map(listItem.treeChildren, ((child)=>{
        currentNumber = listItem_UpdateDisplayNumberRecursively(listItem, child, currentNumber)
    }))

    return currentNumber
}
